import { Component, Input } from '@builder.io/sdk';

import { buttonFields } from 'molecules/Button/config';
import { iconIds } from 'molecules/Icon/types';
import imageField from 'molecules/Image/config';

import { rtcCardColorField } from 'organisms/Cards/config';

const callOutCardFields = [
  {
    name: 'heading',
    type: 'string',
    defaultValue: 'Heading Text',
    helperText: 'Main heading text displayed at the top of the card.',
  },
  {
    name: 'body',
    type: 'richText',
    defaultValue: '<p>Here is your Copy. Click on me to edit content!</p>',
    helperText: 'Body text or description for the card. Supports basic formatting.',
  },
  {
    name: 'button',
    type: 'object',
    subFields: buttonFields,
    helperText: 'Optional button configuration (label, link, etc).',
  },
  {
    name: 'mediaType',
    type: 'string',
    defaultValue: 'image',
    enum: [
      { label: 'Image', value: 'image' },
      { label: 'Icon', value: 'icon' },
    ],
    helperText: 'Choose whether to display an image or an icon on the left side of the card.',
  },
  {
    ...imageField(),
    showIf: "options.get('mediaType') === 'image'",
  },
  {
    name: 'iconId',
    type: 'string',
    defaultValue: 'star',
    enum: iconIds,
    helperText: 'Choose an icon from the available set.',
    showIf: "options.get('mediaType') === 'icon'",
  },
  rtcCardColorField,
] as const satisfies DeepReadonly<Input[]>;

const callOutCardConfig = {
  name: 'callOutCard',
  inputs: callOutCardFields,
} as Component;

export type CallOutCardConfigProps = GenerateBuilder<typeof callOutCardFields>;

export default callOutCardConfig;
